module.exports = __webpack_public_path__ + "media/images/photos/25-3852715204a72b32e27b4ee24456705e.jpg";